import { ReactNode } from 'react';

import { BoxProps, Flex, Text } from '@chakra-ui/react';

export type SectionHeaderProps = {
  iconSlot?: ReactNode;
  color?: string;
  titleSlot?: ReactNode;
  descriptionSlot?: ReactNode;
  subtitle?: string;
  containerProps?: BoxProps;
};

export function SectionHeader({
  iconSlot,
  color = 'gray.900',
  titleSlot,
  descriptionSlot,
  subtitle,
  containerProps,
}: SectionHeaderProps) {
  return (
    <Flex display='flex' flexDirection='column' gap={6} textAlign='center' {...containerProps}>
      {titleSlot && titleSlot}
      {descriptionSlot && descriptionSlot}
      {(iconSlot || subtitle) && (
        <Flex
          alignItems='center'
          flexDirection='column'
          margin='0 auto'
          order={-1}
          width='100%'
          gap={{
            base: 4,
            md: 3,
          }}
        >
          {iconSlot && iconSlot}
          {!!subtitle && (
            <Flex
              alignItems='center'
              alignSelf='normal'
              gap={4}
              _after={{
                content: '""',
                display: 'block',
                width: '100%',
                height: '0.5px',
                backgroundColor: color,
                flex: 1,
              }}
              _before={{
                content: '""',
                display: 'block',
                width: '100%',
                height: '0.5px',
                backgroundColor: color,
                flex: 1,
              }}
            >
              <Text
                color={color}
                fontFamily='condensed'
                fontSize='0.9375rem'
                fontWeight='500'
                letterSpacing='.8px'
                textTransform='uppercase'
              >
                {subtitle}
              </Text>
            </Flex>
          )}
        </Flex>
      )}
    </Flex>
  );
}
